<template>
    <div>
        <HeaderPart v-if="organizer !== null" />
        <router-view />
        <loading-modal v-if="loading" />
        <message-modal v-if="message.length > 0" :message="message" :type="messageType" />
        <confirm-modal v-if="confirmMessage.length > 0 && confirmAction !== null" :message="confirmMessage" :action="confirmAction" />
    </div>
</template>
<script>
import LoadingModal from './components/modal/LoadingModal.vue';
import MessageModal from './components/modal/MessageModal.vue';
import ConfirmModal from './components/modal/ConfirmModal.vue';
import HeaderPart from './components/HeaderPart.vue';

export default {
    components: {
        LoadingModal,
        MessageModal,
        ConfirmModal,
        HeaderPart,
    },

    metaInfo: {
        title: 'IT Event Management System',
    },

    data() {
        return {
            loading: false,
            message: '',
            messageType: '',

            confirmMessage: '',
            confirmAction: null,

            organizer: null,

            errors: {},
        };
    },

    mounted() {
        this.authenticate();
    },

    methods: {
        setLoading(status = false) {
            this.loading = status;
        },

        setErrorMessage(message = '') {
            this.message = message;
            this.messageType = 'error';
        },

        setMessage(message = '') {
            this.messageType = 'message';
            this.message = message;
        },

        closeMessage() {
            this.message = '';
            this.messageType = '';
        },

        showConfirm(message, action) {
            this.confirmMessage = message;
            this.confirmAction = action;
        },

        closeConfirm() {
            this.confirmMessage = '';
            this.confirmAction = null;
        },

        disableBodyScroll() {
            document.body.classList.add('overflow-hidden');
        },

        enableBodyScroll() {
            document.body.classList.remove('overflow-hidden');
        }
    },
}
</script>
